import styled from "styled-components";

export const Flashcard = styled.div`
	aspect-ratio: 1;
	max-width: 400px;
	min-width: 200px;
	display: flex;
	align-items: center;
	gap: 5px;
	justify-content: center;
	padding: 20px;
	cursor: pointer;
`;

export const CircleButton = styled.div`
	position: relative;
	padding: 5px;
	color: white;
	cursor: pointer;
	margin: 5px;
	&::before {
		content: " ";
		position: absolute;
		top: 5.5px;
		top: ${props => props.$top};
		left: 1px;
		left: ${props => props.$left};
		background-color: red;
		border-radius: 50%;
		width: 100%;
		aspect-ratio: 1;
		z-index: -1;
	}
`;

export const Text = styled.div`
	color: ${props => {
		if (props.$currentLanguage === 0) {
			return "red";
		} else {
			return "black";
		}
	}};
	font-size: 30px;
	text-align: center;
	cursor: default;
`;

export const SmallInstructionText = styled.p`
	left: 0px;
	right: 0px;
	top: 15px;
	position: absolute;
	margin: 0;
	text-align: center;
	color: gray;
	cursor: default;
`;

export const SettingsContainer = styled.div`
	padding: 5px;
	left: 0px;
	right: 0px;
	position: absolute;
	display: flex;
	justify-content: center;
	gap: 10px;
	background-color: #ffffffaa;
	-webkit-backdrop-filter: blur(10px);
	backdrop-filter: blur(10px);
`;

export const BottomButton = styled.button`
	font-family: "Bebas Neue";
	background-color: lightgray;
	position: absolute;
	bottom: -15px;
	right: -15px;
	left: -15px;
	font-size: 35px;
	padding: -15px;
	color: white;
	border-radius: 2px 2px 35px 35px;
	border: solid 2px #aaaaaa;
	cursor: pointer;

	bottom: 5px;
	right: 5px;
	left: 5px;
`;
